import { Injectable } from '@angular/core';
import { PKCEEncoderService } from './p-k-c-e-encoder.service';
import { HashService } from 'src/app/shared/crypto/hash.service';
import { ArrayBufferToBinaryStringConversionService } from 'src/app/shared/convert/services/array-buffer-to-binary-string-conversion.service';
import { BinaryStringToArrayBufferConversionServiceService } from 'src/app/shared/convert/services/binary-string-to-array-buffer-conversion-service.service';
import { AuthModule } from '../auth.module';
import { PKCEConfigurationService } from '../../configuration/auth/p-k-c-e/p-k-c-e-configuration.service';


@Injectable({
  providedIn: AuthModule
})
export class PKCECodeChallengeService {

  get pkceConfiguration() {
    return this.pkceConfigurationService.configuration;
  }

  get code_challenge_method() {
    return this.pkceConfiguration.code_challenge_method;
  }

  constructor(private hashService: HashService,
              private arrayBufferToBinaryStringConversionService: ArrayBufferToBinaryStringConversionService,
              private binaryStringToArrayBufferConversionService: BinaryStringToArrayBufferConversionServiceService,
              private pkceEncodeService: PKCEEncoderService,
              private pkceConfigurationService: PKCEConfigurationService
              ) {}

  async createCodeChallenge(verifier) {
    if (this.code_challenge_method === 'S256') {
      const buffer = this.binaryStringToArrayBuffer(verifier);
      const sha = await this.sha256(buffer);
      return this.pkceEncode(this.arrayBufferToBinaryString(sha));
    } else {
      return verifier;
    }
  }

  async sha256(s) {
    return await this.hashService.sha256(s);
  }

  pkceEncode(str) {
    return this.pkceEncodeService.encode(str);
  }

  arrayBufferToBinaryString(buffer) {
    return this.arrayBufferToBinaryStringConversionService.run(buffer);
  }

  binaryStringToArrayBuffer(s) {
    return this.binaryStringToArrayBufferConversionService.run(s);
  }
}
